
riot.tag2('product-edit-parameters-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Характеристики товаров</div>\n    </yield>\n    <yield to="body">\n      <form onchange="{change}">\n        <product-edit-parameters name="specifications" value="{item.specifications}">\n          <yield to="toolbar">\n            <button class="btn btn-success" type="button" onclick="{parent.parent.copySpecifications}" title="Скопировать из другого товара"><i class="fa fa-copy"></i></button>\n\n          </yield>\n        </product-edit-parameters>\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Выбрать</button>\n    </yield>\n  </bs-modal>\n', '', '', function(opts) {
'use strict';

var self = this;

self.on('mount', function () {
    self.tags['bs-modal'].mixin('change');
    self.tags['bs-modal'].item = {
        specifications: opts.specifications
    };

    /*self.tags['bs-modal'].isAddSpecifications = 1
         self.tags['bs-modal'].typeChange = e => {
        self.tags['bs-modal'].isAddSpecifications = e.target.value
    }*/

    self.tags['bs-modal'].copySpecifications = function () {
        modals.create('products-list-select-modal', {
            type: 'modal-primary',
            size: 'modal-lg',
            submit: function submit() {
                var _this = this;
                var items = this.tags.catalog.tags.datatable.getSelectedRows();

                if (items.length) {
                    API.request({
                        object: 'Product',
                        method: 'Info',
                        data: { id: items[0].id },
                        success: function success(response) {
                            self.tags['bs-modal'].item = {
                                specifications: response.specifications
                            };
                            _this.modalHide();
                            self.update();
                        }
                    });
                }
            }
        });
    };
});
});


// WEBPACK FOOTER //
// ./pages/products/products/product-edit-parameters-modal.tag